/* eslint-disable no-shadow */
import { ReactNode } from 'react';

export enum ROUTES {
  CATEGORIES = '/categories',
  SUB_CATEGORIES = '/subcategories',
  SUB_SUB_CATEGORIES = '/subsubcategories',
  LOCATIONS = '/locations',
  MILEAGE = '/mileage',
  MILEAGE_TOO_HIGH = '/mileage-too-high',
  IMAGE_UPLOAD = '/image-upload',
  ISSUE_SUBMITTED = '/issue-submitted',
  COVERAGE = '/coverage',
  BENEFITS = '/benefits',
  PAINTED_DOOR = '/door',
  VEHICLE_CONCERN_DETAILS = '/vehicle-concern-details',
  LOADING = '/loading',
}

export type RouteItem = {
  path: ROUTES;
  component: ReactNode;
};

export enum ERRORS {
  DEFAULT = 'Something went wrong, please try again later',
}
